import request from '../../../axios';

export const getSponserList = async () => {
  const {data}: {data: getSponserListResponse} = await request.get(
    '/api/v2/notification/sponsor',
  );
  return data;
};
